<template>
  <section>
    <div v-for='(section) in content'>
      <!-- Columns -->
      <div v-for='(column) in section.columns' :style='[(size!="smartphone") ? {"width" : columnWidth(column.width)+"%" } : ""]' >
        <!-- Blocks -->
        <template v-for="(block, index) in column.blocks">

          <videoblock v-if='block.type=="video"' :block='block' />

          <!-- Heading -->
          <heading v-if='block.type=="heading"'
                   :level='block.content.level'
                   :text='block.content.text' />

          <!-- Text -->
          <div v-if='block.type=="text"'
               v-html='block.content.text' />

         <!-- Text -->
         <calendar v-if='block.type=="table"' :block='block' />

         <!-- Text -->
         <hr v-if='block.type=="ruler"' />

          <!-- Figure -->
          <figure v-if='block.type=="image"'>
            <srcset :class='{"round" : block.content.crop}' :file="page.files[block.content.image[0]]" />
          </figure>

          <!-- Button -->
          <button v-if='block.type=="link-button"'
                  @click='goTo(block.content.target)'
                  :class='[ (block.content.fullwidth == "true") ? "fullwidth" : "" , block.content.alignment ]'
                  v-html='block.content.caption'/>
          </button>

          <!-- List -->
          <div v-if='block.type=="list"' v-html='block.content.text' />

          <!-- Figure -->
          <gallery v-if='block.type=="gallery"'
                   :filenames='block.content.images'
                   :files='page.files'
                   :sizes='columnWidth(column.width)+"vw"' />

          <!-- Quote -->
          <blockquote v-if='block.type=="quote"' v-html='block.content.text' />

          <!-- Guides -->
          <pages v-if='block.type=="pages"' :block='block' />

        </template>
        <!-- Blocks End -->
      </div>
      <!-- Columns End -->
    </div>
  </section>
</template>

<script>
import mixins from '.././mixins.js';
export default {
  mixins: [mixins], //kirby(), urltopath(), etc
  props: ['content', 'page'],
  methods: {
    columnWidth: function(width) {
      return parseInt(100 * eval(width));
    },
  }
}
</script>

<style scoped>
  section > div {
    width: var(--columnwidth);
    display: flex;
    flex-direction: var(--columndirection);
    padding-top: 1em;
    padding-bottom: 1em;
  }

  section > div > div {
    width: var(--columnwidth);
    box-sizing: border-box;
    padding-right: var(--columnpadding);
  }

  figure {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    overflow: hidden;
  }

  hr {
    border: none;
    border-top: var(--thinline);
    outline: none;
    margin-top: 2em;
    margin-bottom: 2em;
  }

</style>
